import { getInitialDateRange } from '../../../../../../../features/components/Calendar/CalendarTable'
import { CALENDAR_VIEW_TYPE } from '../../../../../../../constants/selectLists/calendarList'

export const initialPeriod = getInitialDateRange(CALENDAR_VIEW_TYPE.YEAR)
